import ImpressionTimer from "@components/impression-timer/ImpressionTimer";
import { usePostAdClickMutation } from "@mwServices/Ads";
import { Col, Row } from "antd";
import { Link } from "react-router-dom";

interface HeaderAdProps {
    campaignUrl: string;
    adId: number;
    imageUrl: string;
    style?: any;
}

const HeaderAd = ({ campaignUrl, adId, imageUrl, style }: HeaderAdProps) => {
    const [postAdClick, postAdClickResponse] = usePostAdClickMutation();
    const styleSettings: any = {
        width: '100%',
        ...style,
    };

    return (
        <ImpressionTimer adId={adId}>
            <Row
                align={'stretch'}
                style={styleSettings}>
                <Col xs={24}>
                    <Link
                        className='custom-header-ad'
                        to={`${campaignUrl}`}
                        target="_blank"
                        onClick={() => {
                            postAdClick(adId);
                        }}>
                        <img src={imageUrl} />
                    </Link>
                </Col>
            </Row>
        </ImpressionTimer>
    );
}

export default HeaderAd;
